import * as React from 'react';
import { Controller, IDynamicLoader, Loader, Toolbar } from '@tencent/workbench';
import { SizeWithRatioFeature } from './size-with-ratio-feature';
import { TOOLBAR_ITEMS, WIDTH_CONFIG, HEIGHT_CONFIG, SIZE_RATIO_CONFIG } from './config';
import { CustomNumberInput } from '@framework/workbench/common/components/custom-number-input';
import i18n from '@i18next/i18n';
import Checkbox from '@tencent/dui/lib/components/Checkbox';
import NoChangeAspectType from '@src/slide/domain/ui-model/element-modeles/property/lock/size-style-type';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import { SpinOptions } from '@src/framework/workbench/drawer/ui/layout/size/config';
import { ISizeFeature } from '../../drawer/ui/layout/size/size-interface';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
})
export class SizeWithRatioController {
    private constructor(
        private readonly feature: SizeWithRatioFeature,
        @Loader(ISizeFeature) private loader: IDynamicLoader<ISizeFeature>,
    ) {}

    private get sizeFeature() {
        return this.loader.instance!;
    }

    @Toolbar(SIZE_RATIO_CONFIG.id, 'content')
    public renderContent() {
        const height = this.feature.getHeight();
        const width = this.feature.getWidth();
        const aspectRatio = this.getNoChangeAspect(this.feature.getAspectRatio());
        return <div style={{ display: 'flex', flexDirection: 'row', position: 'relative', bottom: 2 }}>
            <div>
                <div style={{ marginBottom: 4 }}>
                    <CustomNumberInput
                        onChange={this.changeWidth}
                        value={width}
                        toFixed={2}
                        step={0.1}
                        min={0}
                        max={50}
                        allowDecimal={true}
                        suffix={i18n.t('厘米')}
                        label={WIDTH_CONFIG.content}
                        labelStyle={{ width: 'unset' }}
                        onBlur={this.handleNumberInputBlur}
                        onFocus={this.handleNumberInputFocus}
                    />
                </div>
                <div>
                    <CustomNumberInput
                        onChange={this.changeHeight}
                        value={height}
                        toFixed={2}
                        step={0.1}
                        min={0}
                        max={50}
                        allowDecimal={true}
                        suffix={i18n.t('厘米')}
                        label={HEIGHT_CONFIG.content}
                        labelStyle={{ width: 'unset' }}
                        onBlur={this.handleNumberInputBlur}
                        onFocus={this.handleNumberInputFocus}
                    />
                </div>
            </div>
            <div onClick={this.onClick} style={{ height: 52, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <div style={{
                    width: 11,
                    height: 10,
                    borderTop: '1px solid rgba(0, 0, 0, 0.16)',
                    borderRight: '1px solid rgba(0, 0, 0, 0.16)',
                }}></div>
                <Tooltip title={SIZE_RATIO_CONFIG.content} trigger="hover">
                    <Checkbox
                        style={{ width: 20, height: 20 }}
                        checked={!!aspectRatio}
                        onChange={this.feature.changeAspectRatio}
                    />
                </Tooltip>
                <div style={{
                    width: 11,
                    height: 10,
                    borderBottom: '1px solid rgba(0, 0, 0, 0.16)',
                    borderRight: '1px solid rgba(0, 0, 0, 0.16)',
                }}></div>
            </div>
        </div>;
    }

    // 获取锁定纵横比的类型，是锁定，未锁定，还是多选态
    private getNoChangeAspect = noChangeAspectType => noChangeAspectType === NoChangeAspectType.NO_CHANGE_ASPECT
    || noChangeAspectType === NoChangeAspectType.MULTI;

    private onClick = (e) => {
        e.nativeEvent.stopImmediatePropagation();
        e.stopPropagation();
        e.preventDefault();
    };

    private changeWidth = (value, from) => {
        value = parseFloat(value);
        const { width } = this.sizeFeature.getValidValue(
            { width: value },
            from, SpinOptions.max, SpinOptions.min,
        );
        this.feature.handleWidthChange(width, from);
    };

    private changeHeight = (value, from) => {
        value = parseFloat(value);
        const { height } = this.sizeFeature.getValidValue(
            { height: value },
            from, SpinOptions.max, SpinOptions.min,
        );
        this.feature.handleHeightChange(height, from);
    };

    private handleNumberInputBlur = () => {
        this.feature.handleNumberInputBlur();
    };

    private handleNumberInputFocus = () => {
        this.feature.handleNumberInputFocus();
    };
}
